module.exports = __webpack_public_path__ + "static/media/team1.7287a964.png";